module.exports = __webpack_public_path__ + "img/ORDER-HW.592eab45.png";